<app-navbar></app-navbar>
<div class="container-flex">
    <div class="my-container">
        <div class="section-title-container">
            <div class="row">
                <h3 class="info-title">
                    Noticias del PARLACEN
                    <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-news">
                        Agregar
                    </button>
                    <button class="btn btn-success btn-sm ml-2" (click)="listarNoticias()">
                        Refrescar tabla
                    </button>
                </h3>
                <button type="button" class="btn btn-outline-dark outline-leer-mas">
                    <a class="nav-link" routerLink="/inicio">Inicio</a>
                </button>
            </div>
        </div>
        <div class="section-body-container">
            <div class="m-5 p-5" *ngIf="!news || !news?.length">

            </div>
            <table class="news-table table table-striped table-borderless table-responsive table-hover"
                *ngIf="news && news?.length">
                <caption class="sr-only">Noticias del PARLACEN</caption>
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Título</th>
                        <th scope="col">Autor</th>
                        <th scope="col">Imagen</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of news | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize; let i = index;"
                        class="info-text">
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ item.type | titlecase }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.author }}</td>
                        <td>
                            <a [href]="cleanURL(item.image)" class="text-sky-blue" *ngIf="item.image" target="_blank">
                                Imagen principal existente
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </td>
                        <td class="text-center d-flex">
                            <div class="mr-1">
                                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-news"
                                    (click)="setNews(item)">
                                    Ver
                                </button>
                            </div>
                            <div class="mr-1">
                                <button class="btn btn-warning btn-sm mt-1" data-toggle="modal"
                                    data-target="#update-news" (click)="setNews(item)">
                                    Editar
                                </button>
                            </div>
                            <div>
                                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal"
                                    data-target="#delete-news" (click)="setNews(item)">
                                    Eliminar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center" [collectionSize]="news?.length" [(page)]="page"
                [boundaryLinks]="true" [pageSize]="pageSize" size="sm" [maxSize]="5" [rotate]="true"
                *ngIf="news && news?.length">
            </ngb-pagination>
        </div>
    </div>
</div>
<div class="text-center spinner-container" *ngIf="loading">
    <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!-- Add News ∆ Modal ∆ -->
<div class="modal fade" id="add-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #addNews="ngForm" (submit)="agregarNoticia()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="add-news-title">Agregar Noticia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanNews()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="add-type" class="group-title pb-1">
                            Tipo de Noticia
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-type" #type="ngModel" [(ngModel)]="noticia.type"
                            name="type" required aria-required="true" [disabled]="isSubmitting">
                            <option *ngFor="let type of newsTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-langague" class="group-title pb-1">
                            Idioma
                            <small style="color: red;">*</small>
                        </label><br>
                        <input type="radio" [value]="'en'" name="language" [(ngModel)]="noticia.lang"> Inglés
                        <input type="radio" [value]="'es'" name="language" [(ngModel)]="noticia.lang"> Español
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-title" class="group-title pb-1">
                            Título
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-title" #title="ngModel"
                            [(ngModel)]="noticia.title" name="title" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-author" class="group-title pb-1">
                            Autor
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-author" #author="ngModel"
                            [(ngModel)]="noticia.author" name="author" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-creationDate" class="group-title pb-1">
                            Fecha de Publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="date" class="form-control" id="add-creationDate" #creationDate="ngModel"
                            [(ngModel)]="noticia.creationDate" name="creationDate" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-creationTime" class="group-title pb-1">
                            Hora de publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="time" class="form-control" id="add-creationTime" #creationTime="ngModel"
                            [(ngModel)]="noticia.creationTime" name="creationTime" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-introduction" class="group-title pb-1">Breve descripción</label>
                        <textarea type="introduction" class="form-control" id="add-introduction" #introduction="ngModel"
                            [(ngModel)]="noticia.introduction" name="introduction" required aria-required="true"
                            [readonly]="isSubmitting" rows="3">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-image0" class="group-title pb-1">
                            Imagen Principal
                            <small style="color: red;">*</small>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="add-image0"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 0)"
                                    [disabled]="isSubmitting">
                                <label class="custom-file-label" id="add-image-label0" for="add-image0">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-imgCredits" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="add-imgCredits" #imgCredits="ngModel"
                            [(ngModel)]="noticia.imgCredits" name="imgCredits" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-text" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="add-text" #text="ngModel"
                            [(ngModel)]="noticia.text" name="text" required aria-required="true"
                            [readonly]="isSubmitting" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-image1" class="group-title pb-1">
                            Imagen
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="add-image1"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 1)"
                                    [disabled]="isSubmitting">
                                <label class="custom-file-label" id="add-image-label1" for="add-image1">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-imgCredits1" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="add-imgCredits1" #imgCredits1="ngModel"
                            [(ngModel)]="noticia.imgCredits1" name="imgCredits1" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-text1" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="add-text1" #text1="ngModel"
                            [(ngModel)]="noticia.text1" name="text1" required aria-required="true"
                            [readonly]="isSubmitting" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-image2" class="group-title pb-1">
                            Imagen
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="add-image2"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 2)"
                                    [disabled]="isSubmitting">
                                <label class="custom-file-label" id="add-image-label2" for="add-image2">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-imgCredits2" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="add-imgCredits2" #imgCredits2="ngModel"
                            [(ngModel)]="noticia.imgCredits2" name="imgCredits2" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-text2" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="add-text2" #text2="ngModel"
                            [(ngModel)]="noticia.text2" name="text2" required aria-required="true"
                            [readonly]="isSubmitting" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-image3" class="group-title pb-1">
                            Imagen
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="add-image3"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 3)"
                                    [disabled]="isSubmitting">
                                <label class="custom-file-label" id="add-image-label3" for="add-image3">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-imgCredits3" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="add-imgCredits3" #imgCredits3="ngModel"
                            [(ngModel)]="noticia.imgCredits3" name="imgCredits3" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-text3" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="add-text3" #text3="ngModel"
                            [(ngModel)]="noticia.text3" name="text3" [readonly]="isSubmitting" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-links" class="group-title pb-1">Enlaces Relacionados</label>
                        <textarea type="text" class="form-control" id="add-links" #links="ngModel"
                            [(ngModel)]="noticia.links" name="links" required aria-required="true"
                            [readonly]="isSubmitting" rows="9">
                        </textarea>
                        <small id="linksHelp" class="form-text text-muted info-text">Ingrese los enlaces separados por
                            punto y coma(;).</small>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanNews()"
                        [disabled]="isSubmitting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting">
                        Agregar Noticia
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- View News ∆ Modal ∆ -->
<div class="modal fade" id="view-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="view-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-center  p-4 bg-dark">
                <h5 class="modal-title group-title w-100 text-white" id="view-news-title">Ver Noticia</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanNews()">
                    <span aria-hidden="true" class="text-white">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group pb-4">
                    <label for="view-type" class="group-title pb-1">
                        Tipo de Noticia
                    </label>
                    <input type="text" class="form-control" id="view-type" [value]="noticia.type" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-lang" class="group-title pb-1">
                        Idioma
                    </label>
                    <input type="text" class="form-control" id="view-lang" [value]="noticia.lang" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-title" class="group-title pb-1">
                        Título
                    </label>
                    <input type="text" class="form-control" id="view-title" [value]="noticia.title" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-author" class="group-title pb-1">
                        Autor
                    </label>
                    <input type="text" class="form-control" id="view-author" [value]="noticia.author" readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-creationDate" class="group-title pb-1">
                        Fecha de Publicación
                    </label>
                    <input type="date" class="form-control" id="view-creationDate" [value]="noticia.creationDate"
                        readonly>
                </div>
                <div class="form-group pb-4">
                    <label for="view-creationTime" class="group-title pb-1">
                        Hora de publicación
                    </label>
                    <input type="time" class="form-control" id="view-creationTime" [value]="noticia.creationTime"
                        readonly>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.introduction">
                    <label for="view-introduction" class="group-title pb-1">Breve descripción</label>
                    <textarea type="introduction" class="form-control" id="view-introduction"
                        [value]="noticia.introduction" readonly rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4 d-block">
                    <label class="group-title pb-1">
                        Imagen Principal
                    </label>
                    <br>
                    <img [src]="noticia.image" draggable="true" alt="Imagen Principal de Noticia" *ngIf="noticia.image"
                        width="auto" height="auto">
                    <br>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.imgCredits">
                    <label for="add-imgCredits" class="group-title pb-1">
                        Créditos de Imagen
                    </label>
                    <input type="text" class="form-control" id="view-imgCredits" [value]="noticia.imgCredits" readonly>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.text">
                    <label for="view-text" class="group-title pb-1">Texto</label>
                    <textarea type="text" class="form-control" id="view-text" [value]="noticia.text" readonly rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4 d-block" *ngIf="noticia.image1">
                    <label class="group-title pb-1">
                        Imagen
                    </label>
                    <br>
                    <img [src]="noticia.image1" draggable="true" alt="Imagen de Noticia" *ngIf="noticia.image1"
                        width="auto" height="auto">
                    <br>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.imgCredits1">
                    <label for="add-imgCredits1" class="group-title pb-1">
                        Créditos de Imagen
                    </label>
                    <input type="text" class="form-control" id="view-imgCredits1" [value]="noticia.imgCredits1"
                        readonly>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.text1">
                    <label for="view-text1" class="group-title pb-1">Texto</label>
                    <textarea type="text" class="form-control" id="view-text1" [value]="noticia.text1" readonly
                        rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4 d-block" *ngIf="noticia.image2">
                    <label class="group-title pb-1">
                        Imagen
                    </label>
                    <br>
                    <img [src]="noticia.image2" draggable="true" alt="Imagen de Noticia" *ngIf="noticia.image2"
                        width="auto" height="auto">
                    <br>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.imgCredits2">
                    <label for="add-imgCredits2" class="group-title pb-1">
                        Créditos de Imagen
                    </label>
                    <input type="text" class="form-control" id="view-imgCredits2" [value]="noticia.imgCredits2"
                        readonly>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.text2">
                    <label for="view-text2" class="group-title pb-1">Texto</label>
                    <textarea type="text" class="form-control" id="view-text2" [value]="noticia.text2" readonly
                        rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4 d-block" *ngIf="noticia.image3">
                    <label class="group-title pb-1">
                        Imagen
                    </label>
                    <br>
                    <img [src]="noticia.image3" draggable="true" alt="Imagen de Noticia" *ngIf="noticia.image3"
                        width="auto" height="auto">
                    <br>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.imgCredits3">
                    <label for="add-imgCredits3" class="group-title pb-1">
                        Créditos de Imagen
                    </label>
                    <input type="text" class="form-control" id="view-imgCredits3" [value]="noticia.imgCredits3"
                        readonly>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.text3">
                    <label for="view-text3" class="group-title pb-1">Texto</label>
                    <textarea type="text" class="form-control" id="view-text3" [value]="noticia.text3" readonly
                        rows="9">
                    </textarea>
                </div>
                <div class="form-group pb-4" *ngIf="noticia.links">
                    <label for="view-links" class="group-title pb-1">Enlaces relacionados</label>
                    <a *ngFor="let link of noticia.links.split(';')" [href]="cleanURL(link)"></a>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanNews()">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Delete News ∆ Modal ∆ -->
<div class="modal fade" id="delete-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="delete-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #deleteNews="ngForm" (submit)="eliminarNoticia()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="delete-news-title">Eliminar Noticia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanNews()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="delete-title" class="group-title pb-1">
                            Título
                        </label>
                        <input type="text" class="form-control" id="delete-title" [value]="noticia.title" readonly>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <p class="info-text">
                                ¿Está seguro de que desea eliminar esta noticia?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cleanNews()"
                        [disabled]="isDeleting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
                        Eliminar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Update News ∆ Modal ∆ -->
<div class="modal fade" id="update-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="update-news-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #updateNews="ngForm" (submit)="actualizarNoticia()">
                <div class="modal-header text-center  p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="update-news-title">Actualizar Noticia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanNews()">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="update-type" class="group-title pb-1">
                            Tipo de Noticia
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="update-type" #type="ngModel" [(ngModel)]="noticia.type"
                            name="type" required aria-required="true" [disabled]="isSubmitting">
                            <option *ngFor="let type of newsTypes" [value]="type">{{type}}</option>
                        </select>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-langague" class="group-title pb-1">
                            Idioma
                            <small style="color: red;">*</small>
                        </label><br>
                        <input type="radio" [value]="'en'" name="language" [(ngModel)]="noticia.lang"> Inglés
                        <input type="radio" [value]="'es'" name="language" [(ngModel)]="noticia.lang"> Español
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-title" class="group-title pb-1">
                            Título
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="update-title" #title="ngModel"
                            [(ngModel)]="noticia.title" name="title" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-author" class="group-title pb-1">
                            Autor
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="update-author" #author="ngModel"
                            [(ngModel)]="noticia.author" name="author" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-creationDate" class="group-title pb-1">
                            Fecha de Publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="date" class="form-control" id="update-creationDate" #creationDate="ngModel"
                            [(ngModel)]="noticia.creationDate" name="creationDate" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-creationTime" class="group-title pb-1">
                            Hora de publicación
                            <small style="color: red;">*</small>
                        </label>
                        <input type="time" class="form-control" id="update-creationTime" #creationTime="ngModel"
                            [(ngModel)]="noticia.creationTime" name="creationTime" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-introduction" class="group-title pb-1">Breve descripción</label>
                        <textarea type="introduction" class="form-control" id="update-introduction"
                            #introduction="ngModel" [(ngModel)]="noticia.introduction" name="introduction" required
                            aria-required="true" [readonly]="isUpdating" rows="3">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-image0" class="group-title pb-1">
                            Imagen Principal
                            <small style="color: red;">*</small>
                            <a [href]="noticia.image" class="text-sky-blue" *ngIf="noticia.image">
                                Imagen principal existente
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="update-image0"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 0)"
                                    [disabled]="isUpdating">
                                <label class="custom-file-label" id="update-image-label0" for="update-image0">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-imgCredits" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="update-imgCredits" #imgCredits="ngModel"
                            [(ngModel)]="noticia.imgCredits" name="imgCredits" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-text" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="update-text" #text="ngModel"
                            [(ngModel)]="noticia.text" name="text" required aria-required="true" [readonly]="isUpdating"
                            rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-image1" class="group-title pb-1">
                            Imagen
                            <a [href]="noticia.image1" class="text-sky-blue" *ngIf="noticia.image1">
                                Imagen existente
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="update-image1"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 1)"
                                    [disabled]="isUpdating">
                                <label class="custom-file-label" id="update-image-label1" for="update-image1">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-imgCredits1" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="update-imgCredits1" #imgCredits1="ngModel"
                            [(ngModel)]="noticia.imgCredits1" name="imgCredits1" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-text1" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="update-text1" #text1="ngModel"
                            [(ngModel)]="noticia.text1" name="text1" required aria-required="true"
                            [readonly]="isUpdating" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-image2" class="group-title pb-1">
                            Imagen
                            <a [href]="noticia.image2" class="text-sky-blue" *ngIf="noticia.image2">
                                Imagen existente
                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip"
                                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                </svg>
                            </a>
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="update-image2"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 2)"
                                    [disabled]="isUpdating">
                                <label class="custom-file-label" id="update-image-label2" for="update-image2">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-imgCredits2" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="update-imgCredits2" #imgCredits1="ngModel"
                            [(ngModel)]="noticia.imgCredits2" name="imgCredits2" required aria-required="true"
                            [readonly]="isUpdating">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-text2" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="update-text2" #text2="ngModel"
                            [(ngModel)]="noticia.text2" name="text2" required aria-required="true"
                            [readonly]="isUpdating" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-image3" class="group-title pb-1">
                            Imagen
                        </label>
                        <div class="input-group">
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="update-image3"
                                    aria-describedby="image-desc" (change)="onFileChange($event, 3)"
                                    [disabled]="isSubmitting">
                                <label class="custom-file-label" id="update-image-label3" for="update-image3">
                                    Buscar imagen
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-imgCredits3" class="group-title pb-1">
                            Créditos de Imagen
                        </label>
                        <input type="text" class="form-control" id="update-imgCredits3" #imgCredits3="ngModel"
                            [(ngModel)]="noticia.imgCredits3" name="imgCredits3" required aria-required="true"
                            [readonly]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-text3" class="group-title pb-1">Texto</label>
                        <textarea type="text" class="form-control" id="update-text3" #text3="ngModel"
                            [(ngModel)]="noticia.text3" name="text3" required aria-required="true"
                            [readonly]="isUpdating" rows="9">
                        </textarea>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-links" class="group-title pb-1">Enlaces Relacionados</label>
                        <textarea type="text" class="form-control" id="update-links" #links="ngModel"
                            [(ngModel)]="noticia.links" name="links" required aria-required="true"
                            [readonly]="isSubmitting" rows="9">
                        </textarea>
                        <small id="linksHelp" class="form-text text-muted info-text">Ingrese los enlaces separados por
                            punto y coma(;).</small>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cleanNews()"
                        [disabled]="isUpdating">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning" type="submit" [disabled]="isUpdating">
                        Actualizar Noticia
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>